// extracted by mini-css-extract-plugin
module.exports = {"agreement-link":"Iv0Tj"};